import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography'
import About from './About';
import TextField from '@mui/material/TextField';
import { Link } from 'react-router-dom';
import { FaFacebookF } from "react-icons/fa";
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import { Button } from '@mui/material';
const inputStyle = {
    fieldset: {
        borderRadius: '0px',
        borderWidth: '1px',
        borderColor: '#728085',
        '&.MuiOutlinedInput-notchedOutline': {
            borderColor: '#728085 !important'
        }
    },
    input: {
        color: '#728085',
        '&.MuiInputBase-input::placeholder': {  // ✅ CORRECT SELECTOR
            color: '#728085',
            opacity: 1  // Ensures full opacity
        }
    },
    textarea: {
        color: '#728085',
        '&.MuiInputBase-input::placeholder': {  // ✅ CORRECT SELECTOR
            color: '#728085',
            opacity: 1  // Ensures full opacity
        }
    }
};

// #efeeee
export default function Contact() {
    return (
        <About>
            <Box overflow={'hidden'}>
                <Box paddingLeft={'10%'} width={'65%'}>
                    <Grid container spacing={3}>
                        <Grid size={12}>
                            <Typography component={'h1'} fontWeight={'bold'} fontSize={'1.5rem'} className='dColor'>
                                Contact
                            </Typography>
                        </Grid>
                        <Grid size={12}>
                            <Typography component={'p'} fontSize={'1.125rem'} className='dColor'>
                                RINU Med Spa është një qendër e dedikuar për mirëqenie, jetëgjatësi dhe kujdes të avancuar për lëkurën, trupin dhe mendjen.
                                <br />
                                <br />
                                Për pyetje rreth trajtimeve ose për rezervime, na kontaktoni duke plotësuar të dhënat më poshtë. Do t’ju përgjigjemi sa më shpejt të jetë e mundur.
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
                <Box sx={{ marginY: '80px', width: 1, border: 'solid 1px #DBDAD9' }} />
                <Box paddingLeft={'10%'} width={'65%'}>
                    <Grid container spacing={2}>
                        <Grid size={12}>
                            <Typography component={'h1'} fontWeight={'bold'} fontSize={'1.125rem'}>Adresa</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Typography variant="body1" className='dColor' fontSize={'1.125rem'}>Rr. Bekim Fehmiu, Prishtinë, Derand Hotel (kati -1)</Typography>
                            <Typography variant="body1" className='dColor' fontSize={'1.125rem'}>Prishtine</Typography>
                        </Grid>
                         <Grid size={12}>
                            <Typography component={'h1'} fontWeight={'bold'} fontSize={'1.125rem'}>Email</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Typography variant="body1" className='dColor' fontSize={'1.125rem'} component={Link} to={"mail:info@rinu.me"} target='_blank'>info@rinu.me</Typography>
                        </Grid>
                         <Grid size={12}>
                            <Typography component={'h1'} fontWeight={'bold'} fontSize={'1.125rem'}>Telefoni</Typography>
                        </Grid>
                        <Grid size={12}>
                           <Typography variant="body1" className='dColor' fontSize={'1.125rem'} component={Link} to={"tel:+383 49 090 909"} target='_blank'>+383 49 090 909</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Grid container justifyContent={'space-between'}>
                                <Grid size={{md: 6, xs: 12}}>
                                    <Grid size={12} display={'flex'} height={'100%'}>
                                        <Box display={'flex'} gap={'5px'} alignItems={'center'} marginLeft={'auto'} marginTop={'auto'}>
                                            <Box component={Link} target='_blank' to="https://www.facebook.com/profile.php?id=61576712822656" sx={{ svg: { fill: '#FFF' }, backgroundColor: '#21333B', borderRadius: '100%', height: '30px', width: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <FaFacebookF />
                                            </Box>
                                            <Box component={Link} target='_blank' to="https://www.instagram.com/rinu.medspa/" sx={{ svg: { fill: '#FFF' }, backgroundColor: '#21333B', borderRadius: '100%', height: '30px', width: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <InstagramIcon />
                                            </Box>
                                            {/* <Box component={Link} sx={{ svg: { fill: '#FFF' }, backgroundColor: '#21333B', borderRadius: '100%', height: '30px', width: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                                                <YouTubeIcon />
                                            </Box> */}
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>

                <Box paddingLeft={'10%'} width={'65%'} marginY='80px'>
                    <Grid container spacing={2}>
                        <Grid size={12}>
                            <Typography component={'h1'} fontWeight={'bold'} fontSize={'1.125rem'}>Na shkruaj</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Grid container spacing={3}>
                                <Grid size={12}>
                                    <Grid container spacing={3}>
                                        <Grid size={6}>
                                            <Box sx={inputStyle}>
                                                <TextField fullWidth placeholder='Name' />
                                            </Box>
                                        </Grid>
                                        <Grid size={6}>
                                            <Box sx={inputStyle}>
                                                <TextField fullWidth placeholder='Surname' />
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid size={12}>
                                    <Grid container spacing={3}>
                                        <Grid size={6}>
                                            <Box sx={inputStyle}>
                                                <TextField fullWidth placeholder='Phone' />
                                            </Box>
                                        </Grid>
                                        <Grid size={6}>
                                            <Box sx={inputStyle}>
                                                <TextField fullWidth placeholder='E-Mail' />
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid size={12}>
                                    <Box sx={inputStyle}>
                                        <TextField fullWidth placeholder='Message' multiline rows={7} />
                                    </Box>
                                </Grid>
                                <Grid size={4}>
                                    <Button fullWidth variant='outlined' className='borderRadiusFlat borderWidth2 buttonPaddingY10 defaultBorderColor' sx={{ backgroundColor: 'text.secondary', color: 'text.primary' }}>Dërgo mesazhin</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </About>
    )
}